module.exports = __webpack_public_path__ + "images/icons_v2/thumbs-up-filled-844ee319.svg";